export enum ElectricityMeterDetailField {
  DeviceCategory = 'deviceCategory',
  Direct = 'direct',
  MCT = 'mct',
  Phases = 'phases',
  MeasurementCategory = 'measurementCategory',
  MeasurementType = 'measurementType',
  Mounting = 'mounting',
  Width = 'width',
  Tariffs = 'tariffs',
  IMin = 'iMin',
  IRef = 'iRef',
  IMax = 'iMax',
  CircuitBreakerSize = 'circuitBreakerSize',
  InputSpec = 'inputSpec',
}
